import React from 'react';
import ActionPillMenu from './ActionPillMenu';

const SplitButton = React.forwardRef(function SplitButton({
    variant = 'pill',
    className = '',
    disabled = false,
    primaryLabel,
    primaryAriaLabel,
    primaryDisabled = false,
    primaryType = 'button',
    onPrimaryClick,
    primaryProps = {},
    menuOptions = [],
    menuLabel = 'More options',
    menuClassName = '',
    menuTriggerLabel = 'Open more options',
    menuOpen,
    onMenuOpenChange,
    secondaryContent = <span aria-hidden="true">▾</span>,
    secondaryAriaLabel = menuTriggerLabel,
    secondaryDisabled = false,
    onSecondaryClick,
    secondaryProps = {},
    menuSide = 'secondary',
    ...rootProps
}, ref) {
    const primaryMenu = menuSide === 'primary';
    const mainDisabled = disabled || primaryDisabled;
    const moreDisabled = disabled || secondaryDisabled;
    const menuProps = {
        options: menuOptions,
        menuLabel,
        menuClassName,
        placement: 'top',
        align: primaryMenu ? 'start' : 'end',
        scrollable: false,
        open: menuOpen,
        onOpenChange: onMenuOpenChange,
    };

    return (
        <div
            ref={ref}
            {...rootProps}
            className={`ia-btn3d ia-btn3d--${variant} ia-split-button ${className}`}
            data-ia-split-button="true"
            aria-disabled={mainDisabled && moreDisabled ? 'true' : undefined}
        >
            {primaryMenu ? (
                <ActionPillMenu
                    {...menuProps}
                    disabled={mainDisabled}
                    triggerLabel={primaryAriaLabel}
                    triggerClassName="ia-split-button__action ia-split-button__primary"
                    triggerProps={primaryProps}
                    onTriggerClick={onPrimaryClick}
                >
                    {primaryLabel}
                </ActionPillMenu>
            ) : (
                <button
                    type={primaryType}
                    className="ia-split-button__action ia-split-button__primary"
                    aria-label={primaryAriaLabel}
                    disabled={mainDisabled}
                    onClick={onPrimaryClick}
                    {...primaryProps}
                >
                    {primaryLabel}
                </button>
            )}
            {primaryMenu ? (
                <button
                    type="button"
                    className="ia-split-button__action ia-split-button__secondary"
                    aria-label={secondaryAriaLabel}
                    disabled={moreDisabled}
                    onClick={onSecondaryClick}
                    {...secondaryProps}
                >
                    {secondaryContent}
                </button>
            ) : (
                <ActionPillMenu
                    {...menuProps}
                    disabled={moreDisabled}
                    triggerLabel={secondaryAriaLabel}
                    triggerClassName="ia-split-button__action ia-split-button__secondary"
                    triggerProps={secondaryProps}
                >
                    {secondaryContent}
                </ActionPillMenu>
            )}
        </div>
    );
});

export default SplitButton;
